const CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID;
const APPLE_SRC = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

export function isAppleClientConfigured() {
  return Boolean(CLIENT_ID);
}

function loadAppleScript() {
  if (window.AppleID?.auth) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${APPLE_SRC}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error('Could not load Apple sign-in.')), {
        once: true,
      });
      return;
    }

    const script = document.createElement('script');
    script.src = APPLE_SRC;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Could not load Apple sign-in.'));
    document.head.appendChild(script);
  });
}

export async function startAppleSignIn() {
  if (!CLIENT_ID) {
    throw new Error('Apple sign-in is not configured.');
  }

  await loadAppleScript();

  if (!window.AppleID?.auth) {
    throw new Error('Apple sign-in failed to load.');
  }

  const nonce = crypto.randomUUID();

  window.AppleID.auth.init({
    clientId: CLIENT_ID,
    scope: 'name email',
    redirectURI: `${window.location.origin}/login`,
    usePopup: true,
    nonce,
  });

  const data = await window.AppleID.auth.signIn();
  const token = data?.authorization?.id_token || data?.id_token;

  if (!token) {
    throw new Error('Apple did not return a sign-in token.');
  }

  return {
    token,
    nonce,
    user: data.user,
  };
}
